<template>
  <div>
    <!--面包屑导航-->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商品管理</el-breadcrumb-item>
      <el-breadcrumb-item>参数列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!--卡片视图-->
    <el-card>
      <!--警告区域-->
      <el-alert title="注意：只允许为第三方分类设置的相关参数" type="warning" :closable="false" show-icon></el-alert>
      <!--选择商品分类区域-->
      <el-row class="cat_opt">
        <el-col>
          <span>选择商品分类：</span>
          <!--选择商品分类的级联选择框-->
          <el-cascader
            v-model="selectedCateKeys"
            :options="cateList"
            :props="cateParps"
            @change="handleChange"
          ></el-cascader>
        </el-col>
      </el-row>
      <!--标签页-->
      <el-tabs v-model="activeName" @tab-click="handleTabClick">
        <!--添加动态参数面板-->
        <el-tab-pane label="动态参数" name="many">
          <!--添加动态按钮-->
          <el-button
            type="primary"
            size="mini"
            :disabled="isBtnDisabled"
            @click="addFormDialog()"
          >添加参数</el-button>
          <!--动态参数表格-->
          <el-table :data="manyTableData" border stripe>
            <!--展开行-->
            <el-table-column type="expand">
              <!--循环渲染tag-->
              <template slot-scope="scope">
                <el-tag
                  closable
                  v-for="(item, index) in scope.row.attr_vals"
                  @close="removeTag(scope.row,index)"
                  :key="index"
                >{{item}}</el-tag>
                <!--+ New Tag-->
                <el-input
                  class="input-new-tag"
                  v-if="scope.row.inputVisible"
                  v-model="scope.row.inputValue"
                  ref="saveTagInput"
                  size="small"
                  @keyup.enter.native="handleInputConfirm(scope.row)"
                  @blur="handleInputConfirm(scope.row)"
                ></el-input>
                <el-button
                  v-else
                  class="button-new-tag"
                  size="small"
                  @click="showInput(scope.row)"
                >+ New Tag</el-button>
              </template>
            </el-table-column>
            <!--索引列-->
            <el-table-column type="index" label="#"></el-table-column>
            <el-table-column label="参数名称" prop="attr_name"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  class="el-icon-edit"
                  size="mini"
                  @click="editFormDialog(scope.row)"
                >编辑</el-button>
                <el-button
                  type="danger"
                  class="el-icon-delete"
                  size="mini"
                  @click="removeParams(scope.row)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <!--添加静态属性面板-->
        <el-tab-pane label="静态属性" name="only">
          <!--添加属性按钮-->
          <el-button
            type="primary"
            size="mini"
            :disabled="isBtnDisabled"
            @click="addFormDialog()"
          >添加属性</el-button>
          <!--静态属性表格-->
          <el-table :data="onlyTableData" border stripe>
            <!--展开行-->
            <el-table-column type="expand">
              <!--循环渲染tag-->
              <template slot-scope="scope">
                <el-tag
                  closable
                  v-for="(item, index) in scope.row.attr_vals"
                  @close="removeTag(scope.row,index)"
                  :key="index"
                >{{item}}</el-tag>
                <!--+ New Tag-->
                <el-input
                  class="input-new-tag"
                  v-if="scope.row.inputVisible"
                  v-model="scope.row.inputValue"
                  ref="saveTagInput"
                  size="small"
                  @keyup.enter.native="handleInputConfirm(scope.row)"
                  @blur="handleInputConfirm(scope.row)"
                ></el-input>
                <el-button
                  v-else
                  class="button-new-tag"
                  size="small"
                  @click="showInput(scope.row)"
                >+ New Tag</el-button>
              </template>
            </el-table-column>
            <!--索引列-->
            <el-table-column type="index" label="#"></el-table-column>
            <el-table-column label="参数名称" prop="attr_name"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  class="el-icon-edit"
                  size="mini"
                  @click="editFormDialog(scope.row)"
                >编辑</el-button>
                <el-button
                  type="danger"
                  class="el-icon-delete"
                  size="mini"
                  @click="removeParams(scope.row)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-card>
    <!--添加参数对话框-->
    <el-dialog
      :title="activeName === 'many' ? '添加动态参数':'添加静态属性'"
      :visible.sync="addDialogVisible"
      width="50%"
      @close="addDialogClosed()"
    >
      <!--添加表单-->
      <el-form :model="addForm" :rules="FormRlues" ref="addFormRef" label-width="100px">
        <el-form-item :label="activeName === 'many' ? '动态参数：':'静态属性：'" prop="attr_name">
          <el-input v-model="addForm.attr_name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addParams()">确 定</el-button>
      </span>
    </el-dialog>

    <!--编辑参数对话框-->
    <el-dialog
      :title="activeName === 'many' ? '编辑动态参数':'编辑静态属性'"
      :visible.sync="editDialogVisible"
      width="50%"
      @close="editDialogClosed()"
    >
      <!--编辑表单-->
      <el-form :model="editForm" :rules="FormRlues" ref="editFormRef" label-width="100px">
        <el-form-item :label="activeName === 'many' ? '动态参数：':'静态属性：'" prop="attr_name">
          <el-input v-model="editForm.attr_name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editParams()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 所有的商品列表
      cateList: [],
      // 级联选择框配置
      cateParps: {
        children: 'children',
        value: 'cat_id',
        label: 'cat_name',
        expandTrigger: 'hover'
      },
      // 级联选择框双向绑定
      selectedCateKeys: [],
      // 标签页默认显示
      activeName: 'many',
      // 动态参数数据
      manyTableData: [],
      // 静态属性数据
      onlyTableData: [],
      // 添加动态参数、静态属性 对话框
      addDialogVisible: false,
      // 添加表单的数据
      addForm: {
        attr_name: ''
      },
      // 表单的验证规则
      FormRlues: {
        attr_name: [
          { required: true, message: '请输入参数名称', trigger: 'blur' }
        ]
      },
      // 控制编辑对话框
      editDialogVisible: false,
      // 编辑表单的数据
      editForm: {
        attr_name: '',
        id: 0,
        attrId: 0
      }
    }
  },
  created() {
    this.getCateList()
  },
  methods: {
    // 获取所有的商品分类
    async getCateList() {
      const { data: res } = await this.$http.get('categories')
      if (res.meta.status !== 200) {
        return this.$message.error('获取商品列表失败')
      }
      this.cateList = res.data
    },
    // 级联选择框选中项变化，会触发这个函数
    async handleChange() {
      this.getParamsList()
    },
    // Tab页签点击事件
    handleTabClick() {
      this.getParamsList()
    },
    // 根据所选的ID和当前的面板，获取对应的属性
    async getParamsList() {
      if (this.selectedCateKeys.length !== 3) {
        this.selectedCateKeys = []
        this.manyTableData = []
        this.onlyTableData = []
        return 0
      }
      const { data: res } = await this.$http.get(
        `categories/${this.cateId}/attributes`,
        { params: { sel: this.activeName } }
      )
      if (res.meta.status !== 200) {
        return this.$message.error('获取' + this.activeName + '失败')
      }
      // 拆分字符串
      res.data.forEach(item => {
        item.attr_vals = item.attr_vals ? item.attr_vals.split(' ') : []
        // 控制New tag的显示与隐藏
        item.inputVisible = false
        // New tag 的内容
        item.inputValue = ''
      })
      if (this.activeName === 'many') {
        this.manyTableData = res.data
      } else {
        this.onlyTableData = res.data
      }
    },
    // 添加参数对话框
    addFormDialog() {
      this.addDialogVisible = true
    },
    // 关闭添加对话框时触发
    addDialogClosed() {
      this.$refs.addFormRef.resetFields()
    },
    // 点击添加表单的确认按钮
    addParams() {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await this.$http.post(
          `categories/${this.cateId}/attributes`,
          {
            attr_name: this.addForm.attr_name,
            attr_sel: this.activeName
          }
        )
        if (res.meta.status !== 201) {
          return this.$message.error('添加参数失败')
        }
        this.$message.success('添加参数成功')
        this.addDialogVisible = false
        this.getParamsList()
      })
    },
    // 打开编辑对话框
    editFormDialog(param) {
      this.editDialogVisible = true
      this.editForm.id = param.cat_id
      this.editForm.attrId = param.attr_id
      this.editForm.attr_name = param.attr_name
    },
    // 点击编辑表单确认按钮
    editParams() {
      this.$refs.editFormRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await this.$http.put(
          `categories/${this.editForm.id}/attributes/${this.editForm.attrId}`,
          {
            attr_name: this.editForm.attr_name,
            attr_sel: this.activeName
          }
        )
        if (res.meta.status !== 200) {
          return this.$message.error('修改失败')
        }
        this.$message.success('修改成功')
        this.editDialogVisible = false
        this.getParamsList()
      })
    },
    // 关闭编辑对话框时触发
    editDialogClosed() {
      this.$refs.editFormRef.resetFields()
    },
    // 表格删除按钮
    // 删除用户
    async removeParams(param) {
      // 弹框提问
      const confirmResult = await this.$confirm(
        '此操作将永久删除该参数, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err)
      // 如果用户点击了确认，则返回字符串 confirm
      // 如果用户点击了取消，则返回字符串 cancle
      // console.log(confirmResult)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除')
      }
      const { data: res } = await this.$http.delete(
        'categories/' + param.cat_id + '/attributes/' + param.attr_id
      )
      if (res.meta.status !== 200) {
        return this.$message.error('删除参数失败')
      }
      this.$message.success('该参数已删除')
      this.getParamsList()
    },
    // 点击New tag 按钮
    showInput(input) {
      input.inputVisible = true
      // 使文本框获得焦点
      // $nextTick 方法的作用为 当页面上的元素被重新渲染时，调用回调函数
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    // 将对 attr_vals 的操作保存到数据库中
    async saveAttrVals(param) {
      const { data: res } = await this.$http.put(
        `categories/${param.cat_id}/attributes/${param.attr_id}`,
        {
          attr_name: param.attr_name,
          attr_sel: this.activeName,
          attr_vals: param.attr_vals.join(' ')
        }
      )
      if (res.meta.status !== 200) {
        this.$message.error('修改参数项失败')
      }
      this.$message.success('修改参数项成功')
    },
    // 关闭New tag 输入框
    async handleInputConfirm(param) {
      param.inputVisible = false
      if (!param.inputValue.trim()) {
        param.inputValue = ''
        return
      }
      param.attr_vals.push(param.inputValue.trim())
      param.inputValue = ''
      this.saveAttrVals(param)
    },
    // 删除 tag
    async removeTag(param, index) {
      param.attr_vals.splice(index, 1)
      this.saveAttrVals(param)
    }
  },
  computed: {
    isBtnDisabled() {
      if (this.selectedCateKeys.length !== 3) {
        return true
      }
      return false
    },
    // 获取当前选中的三级id
    cateId() {
      return this.selectedCateKeys[2]
    }
  }
}
</script>
<style lang="less" scoped>
.cat_opt {
  margin: 15px 0;
}
.el-tag {
  margin-left: 10px;
}
.input-new-tag {
  margin-left: 10px;
  width: 100px;
}
.button-new-tag {
  margin-left: 10px;
}
</style>
